import { render, staticRenderFns } from "./bigDevicesbook.vue?vue&type=template&id=122089d6&scoped=true"
import script from "./bigDevicesbook.vue?vue&type=script&lang=js"
export * from "./bigDevicesbook.vue?vue&type=script&lang=js"
import style0 from "./bigDevicesbook.vue?vue&type=style&index=0&id=122089d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122089d6",
  null
  
)

export default component.exports